import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Disable console.log in production (keep errors/warnings)
import './utils/consoleControl';

// Initialize simple debugger FIRST (before anything else)
// Simple debugger removed for production
// Initialize global error handler early
import './utils/errorHandler';
// Initialize persistent logger
// Persistent logger removed for production

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
